import axios from 'axios';
import apis from '../config';

const deleteStudent = async studentId => {
  if (
    window.confirm(
      'WARNING: You are removing all records of this student, including uploaded documentation. Continue?'
    )
  ) {
    const formData = new FormData();
    formData.append('studentId', studentId);
    formData.append('mode', 'deleteStudent');
    formData.append('auth', localStorage.getItem('token'));
    const output = await axios.post(apis.STUDENTS_API, formData);
    document.location = '/manage/students';
  }
};

export default deleteStudent;
